import { useSettings } from 'Settings'
import { v4 } from 'uuid'

const cct_options = [ "STS", "LDO", "Auto-Floating", "Auto-Grounded" ]
const con_options = [ "Manual", "Auto-Disconnect" ]
const edge_options = [ "Falling Edge", "Rising Edge", "Both Edges"]
const sda_options = [ "Standart and Fast Mode", "Highspeed Mode"]
const bwd_options = ['Floating', 'GDN']

const Preview = () => {
	const [settings] = useSettings();
	const cct = [
		settings['vaux'][0]['constantly connect to'].value,
		settings['vaux'][1]['constantly connect to'].value,
		settings['vaux'][2]['constantly connect to'].value
	]

	const con = [
		settings['vaux gnd'][0]['connection'].value,
		settings['vaux gnd'][1]['connection'].value,
		settings['vaux gnd'][2]['connection'].value
	]

	let t = settings['vsup']['sleep'].value

	const time = {
		h : (Math.floor(t / 3600000)).toString().padStart(2, '0'),
		m : (Math.floor(t / 60000) % 60).toString().padStart(2, '0'),
		s : (Math.floor(t / 1000) % 60).toString().padStart(2, '0'),
		ms : (t % 1000).toString().padStart(3, '0')
	}

	return (
		<>
			{
			[0, 1, 2].map((i) => <text
				key={ v4() }
				className="settings"
				textAnchor="end"
				x="890"
				y={235 + i * 40}>Constantly to {cct_options[cct[i]]}</text>
			)
			}
			{
			[0, 1, 2].map((i) => <text
				key={ v4() }
				className="settings"
				textAnchor="end"
				x="890"
				y={355 + i * 40}>{con_options[con[i]]} Connection</text>
			)
			}
			<text
				key={ v4() }
				className="settings"
				textAnchor="middle"
				x="585"
				y="190"
			>{settings['ldo levels']['v_ulp_ldo'].value + " V"}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="middle"
				x="585"
				y="260"
			>{settings['ldo levels']['v_aux_ldo'].value + " V"}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="middle"
				x="600"
				y="555"
			>{'Address: 0x' + settings['wakeup']['i2c_address'].value.toString(16)}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="middle"
				x="600"
				y="570"
			>{settings['wakeup']['3 wire interface'].value ? '3 Wire Interface' : ''}</text>
			<text
				key={ v4() }
				className="settings"
				x="670"
				y="463"
			>{'Wake-up on ' + edge_options[settings['wakeup']['edge'].value]}</text>
			<text
				key={ v4() }
				className="settings"
				x="670"
				y="523"
			>{sda_options[settings['wakeup']['sda'].value]}</text>
			<text
				key={ v4() }
				className="settings"
				x="742"
				y="100"
			>{`Suspend after ${time.h}:${time.m}:${time.s}.${time.ms}`}</text>
			<text
				key={ v4() }
				className="settings"
				x="110"
				y="60"
			>{'USB Charging Source ' + settings['usb']['charging source'].value + 'mA'}</text>
			<text
				key={ v4() }
				className="settings"
				x="110"
				y="80"
			>{settings['usb']['force hrv_low hi-z'].value ? 'Force HRV_LOW Hi-Z' : ''}</text>
			<text
				key={ v4() }
				className="settings"
				x="110"
				y="100"
			>{settings['usb']['force bat_low hi-z'].value ? 'Force BAT_LOW Hi-Z' : ''}</text>
			<text
				key={ v4() }
				className="settings"
				x="110"
				y="120"
			>{settings['usb']['always disable usb ldo'].value ? 'Always Disable USB LDO' : ''}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="end"
				x="890"
				y="165"
			>{bwd_options[settings['vsup']['behaviour when disabled'].value] + ' when disabled'}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="start"
				x="545"
				y="454"
			>{"de-bouncer " + (settings['wakeup']['de-bouncer'].value ? 'enabled' : 'disabled')}</text>
			<text
				key={ v4() }
				className="settings"
				textAnchor="end"
				x="300"
				y="570"
			>{"Battery Protector " + (settings['supervisory']['battery protector'].value ? 'enabled' : 'disabled')}</text>
		</>
	)
}

export default Preview
